import { render, staticRenderFns } from "./FctCheckbox.vue?vue&type=template&id=1401451e&scoped=true"
import script from "./FctCheckbox.vue?vue&type=script&lang=js"
export * from "./FctCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401451e",
  null
  
)

export default component.exports